module.exports = __webpack_public_path__ + "right.17RlXUkB.svg";